module.exports = __webpack_public_path__ + "static/img/67 (3).e60bb10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67 (3).jpg
// module id = Ws5a
// module chunks = 0